export default __webpack_public_path__ + "static/media/green_pawn.0cde9962.png";